export const USER_NOT_FOUND = "USER_NOT_FOUND";
export const UNEXPECTED_SERVER_RESPONSE = "UNEXPECTED_SERVER_RESPONSE"

export const INCORRECT_FUNCTION_PARAMETERS = "INCORRECT_FUNCTION_PARAMETERS"
